import { NgModule } from '@angular/core';

import { DatePipe, CommonModule } from '@angular/common';
import { AdministracaoRoutingModule } from './administracao-routing.module';
import { AdministracaoFgiComponent } from './administracao-fgi.component';


@NgModule({
  imports: [
    AdministracaoRoutingModule,
    CommonModule,
  ],
  declarations: [
    AdministracaoFgiComponent
  ],
  providers: [
    DatePipe
  ]
})
export class AdministracaoModule { }
